interface RawErrorShape {
  message?: string;
  details?: string;
  hint?: string;
  error_description?: string;
  code?: string;
}

interface PatternRule {
  test: RegExp;
  message: string;
}

const RAW_RULES: PatternRule[] = [
  {
    test: /duplicate key value violates unique constraint/i,
    message: 'Ya existe un registro con esos datos. Revisa que no esté duplicado.',
  },
  {
    test: /violates foreign key constraint/i,
    message: 'No se pudo completar porque falta información relacionada.',
  },
  {
    test: /violates not-null constraint/i,
    message: 'Falta un dato obligatorio. Completa todos los campos requeridos.',
  },
  {
    test: /violates check constraint/i,
    message: 'Alguno de los valores ingresados no es válido.',
  },
  {
    test: /row-level security|permission denied/i,
    message: 'No tienes permisos para realizar esta acción.',
  },
  {
    test: /invalid input syntax/i,
    message: 'Alguno de los datos ingresados tiene un formato inválido.',
  },
  {
    test: /jwt expired|invalid jwt|not authenticated|session.*expired/i,
    message: 'Tu sesión expiró. Vuelve a iniciar sesión.',
  },
  {
    test: /invalid refresh token|refresh token not found|refresh token.*expired/i,
    message: 'Tu sesión caducó. Inicia sesión nuevamente para continuar.',
  },
  {
    test: /numeric field overflow|out of range/i,
    message: 'Uno de los valores numéricos está fuera de rango.',
  },
  {
    test: /does not exist|undefined function|undefined table|relation .* does not exist/i,
    message: 'Ocurrió un error interno. Intenta de nuevo en unos segundos.',
  },
  {
    test: /failed to fetch|network error|networkerror|timeout|fetch failed|load failed/i,
    message: 'No se pudo conectar con el servidor. Revisa tu conexión e intenta de nuevo.',
  },
];

/**
 * Normaliza cualquier error (string, Error, PostgrestError) a un mensaje
 * claro y en español, evitando mostrar el texto crudo de la base de datos.
 */
export function friendlyError(
  err: unknown,
  fallback = 'Ocurrió un error inesperado. Intenta de nuevo.'
): string {
  let raw = '';
  if (typeof err === 'string') {
    raw = err;
  } else if (err && typeof err === 'object') {
    const e = err as RawErrorShape;
    raw = e.message || e.details || e.hint || e.error_description || '';
  }
  raw = raw.trim();
  if (!raw) return fallback;

  for (const rule of RAW_RULES) {
    if (rule.test.test(raw)) return rule.message;
  }

  // Quita prefijos técnicos comunes que no aportan al usuario.
  const clean = raw
    .replace(/^error:\s*/i, '')
    .replace(/^postgresterror:\s*/i, '')
    .trim();

  if (!clean || /^(pgrst|23505|23503|23502|42501|42p01|42703)/i.test(clean)) return fallback;

  return clean;
}